var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaleOrdersV2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6767 1.07141H4.64115C4.16756 1.07141 3.71336 1.25955 3.37848 1.59443C3.0436 1.92931 2.85547 2.3835 2.85547 2.85709V17.1426C2.85547 17.6162 3.0436 18.0703 3.37848 18.4052C3.71336 18.7401 4.16756 18.9282 4.64115 18.9282H15.3553C15.8288 18.9282 16.283 18.7401 16.6179 18.4052C16.9528 18.0703 17.1409 17.6162 17.1409 17.1426V5.53562L12.6767 1.07141Z",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7852 1.07141V4.64278C11.7852 5.11637 11.9733 5.57057 12.3082 5.90545C12.6431 6.24033 13.0972 6.42846 13.5708 6.42846H17.1422",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3787 9.51855H8.45015C8.10284 9.51855 7.76976 9.65652 7.52418 9.90211C7.27859 10.1477 7.14063 10.4808 7.14062 10.8281C7.14063 11.1754 7.27859 11.5085 7.52418 11.7541C7.76976 11.9996 8.10284 12.1376 8.45015 12.1376H11.0692C11.4165 12.1376 11.7496 12.2756 11.9952 12.5212C12.2408 12.7667 12.3787 13.0998 12.3787 13.4471C12.3787 13.7944 12.2408 14.1275 11.9952 14.3731C11.7496 14.6187 11.4165 14.7566 11.0692 14.7566H7.14062",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75781 16.0671V8.20996",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaleOrdersV2);
export default __webpack_public_path__ + "static/media/saleOrdersV2.cd57c1aceead7748ae0fe6665763d8c6.svg";
export { ForwardRef as ReactComponent };